export class OrderItemExtraEntity {
    ItemExtraId!: string;
    OrderItemId!: string;
    Price!: number;
  }
  